import DriveService from "../../../../../services/drive-service";
import StatsRule from "../../../../common/stats-rule";
import FootballState from "../../../../football/state/football-state";
import FootballStatsCategory from "../../../../football/stats/football-stats-category";

export default class FlagPatPassStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PatPass &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const tryFragment = play.getFirstFragment(FootballState.PatTry);
        const code = Number(tryFragment.points.option.code);

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.passedBy.teamId,
            playerId: fragment.passedBy.id,
            driveId: await DriveService.resolveDriveId(play, gameContext),
            fragmentId: fragment.id,
            category: FootballStatsCategory.PAT_PASS,
            values: {
                code,
                attempted: 1,
                completed: play.historyContains(FootballState.PatCompleted)
                    ? 1
                    : 0
            }
        });
    }
}
